import React from 'react';
import { CheckCircle2, ShieldCheck, Zap, Layers } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative overflow-hidden bg-gradient-to-b from-aqua-50 to-white pt-10 pb-12 lg:pt-24 lg:pb-28" data-id="element-153">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] bg-aqua-200/30 rounded-full blur-3xl -z-10" data-id="element-154"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-155">
        <div className="text-center" data-id="element-156">
          <FadeIn data-id="element-157">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-aqua-100 text-aqua-800 font-semibold text-xs sm:text-sm mb-3 md:mb-6" data-id="element-158">
              <span className="relative flex h-2 w-2" data-id="element-159">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-aqua-500 opacity-75" data-id="element-160"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-aqua-600" data-id="element-161"></span>
              </span>
              Sistema N°1 para Instructores en Argentina
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-162">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-display font-black text-deepblue-900 leading-tight mb-4 md:mb-6" data-id="element-163">
              Aquagym Resuelto™ <br data-id="element-164" />
              <span className="text-aqua-600" data-id="element-165">Sistema Completo</span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.15} data-id="element-166">
            <div className="relative mx-auto w-[80%] max-w-md md:max-w-lg mb-4 md:mb-6" data-id="element-167">
              <div className="absolute inset-0 bg-gradient-to-tr from-aqua-400 to-deepblue-400 rounded-3xl transform rotate-3 scale-105 opacity-20 blur-xl" data-id="element-168"></div>
              <img src="https://cdn.magicpatterns.com/uploads/4KeufNXJDxMbxFTLZBjCRZ/heylloyd-image-1776578584338-Photoroom.png" alt="Aquagym Resuelto Megapack" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-169" />
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-170">
            <p className="md:text-2xl text-slate-600 font-medium mb-4 md:mb-8 text-[12px]" data-id="element-171">
              Tu año completo de clases de aquagym listo: fundamentos,
              planificación por niveles, adultos mayores, coreografía con
              música, gestión y mucho más. Sin improvisar nunca más.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-172">
            <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-5 md:mb-10" data-id="element-173">
              <div className="flex items-center gap-1.5 bg-white shadow-sm border border-slate-100 px-2.5 py-1.5 md:px-3 md:py-2 rounded-lg text-xs md:text-sm font-medium text-slate-700" data-id="element-174">
                <Layers className="w-3.5 h-3.5 md:w-4 md:h-4 text-aqua-600" data-id="element-175" />{' '}
                PDF digital
              </div>
              <div className="flex items-center gap-1.5 bg-white shadow-sm border border-slate-100 px-2.5 py-1.5 md:px-3 md:py-2 rounded-lg text-xs md:text-sm font-medium text-slate-700" data-id="element-176">
                <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-aqua-600" data-id="element-177" />{' '}
                Acceso inmediato
              </div>
              <div className="flex items-center gap-1.5 bg-white shadow-sm border border-slate-100 px-2.5 py-1.5 md:px-3 md:py-2 rounded-lg text-xs md:text-sm font-medium text-slate-700" data-id="element-178">
                <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-aqua-600" data-id="element-179" />{' '}
                Todos los niveles
              </div>
              <div className="flex items-center gap-1.5 bg-white shadow-sm border border-slate-100 px-2.5 py-1.5 md:px-3 md:py-2 rounded-lg text-xs md:text-sm font-medium text-slate-700" data-id="element-180">
                <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-aqua-600" data-id="element-181" />{' '}
                Garantía 7 días
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-182">
            <motion.button onClick={scrollToPricing} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full sm:w-auto bg-aqua-600 hover:bg-aqua-700 text-white font-bold text-base md:text-xl px-6 py-3 md:px-8 md:py-4 rounded-xl shadow-lg shadow-aqua-600/30 transition-all animate-pulse-slow inline-flex items-center justify-center gap-2" data-id="element-183">
              💥 QUIERO MI AQUAGYM RESUELTO
            </motion.button>
            <p className="mt-3 text-xs md:text-sm text-slate-500 font-medium flex items-center justify-center gap-2" data-id="element-184">
              <ShieldCheck className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-500" data-id="element-185" />{' '}
              Pago 100% seguro · Mercado Pago | Tarjeta | Transferencia
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}